/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAdmissionStatusOptionsRequest
 */
export interface FindAdmissionStatusOptionsRequest {
    /**
     * 
     */
    lead_ids: Array<string>;
}

/**
 * Check if a given object implements the FindAdmissionStatusOptionsRequest interface.
 */
export function instanceOfFindAdmissionStatusOptionsRequest(value: object): value is FindAdmissionStatusOptionsRequest {
    if (!('lead_ids' in value) || value['lead_ids'] === undefined) return false;
    return true;
}

export function FindAdmissionStatusOptionsRequestFromJSON(json: any): FindAdmissionStatusOptionsRequest {
    return FindAdmissionStatusOptionsRequestFromJSONTyped(json, false);
}

export function FindAdmissionStatusOptionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAdmissionStatusOptionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_ids': json['lead_ids'],
    };
}

export function FindAdmissionStatusOptionsRequestToJSON(json: any): FindAdmissionStatusOptionsRequest {
    return FindAdmissionStatusOptionsRequestToJSONTyped(json, false);
}

export function FindAdmissionStatusOptionsRequestToJSONTyped(value?: FindAdmissionStatusOptionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_ids': value['lead_ids'],
    };
}

